import { useContext, useState, useEffect } from 'react';
import { Modal } from "react-bootstrap";
import PageContext from './PageContext';
import AutoCompleteInput from './AutoCompleteInputCopy.jsx';
import PageInput from './PageInputCopy.jsx';
// import Checkbox from '@mui/material/Checkbox';
// import FormControlLabel from '@mui/material/FormControlLabel';
import { HttpContext } from '../../api-services/HttpService';
import isNumeric from '../functions/isNumeric';
import ApiRequestButton from './ApiRequestButton';
import CCOffcanvas from './CCOffcanvas.tsx';

const AddAdhocPaymentModal = ({ refreshFunction }) => {
    // initialize PageContext
    const {
        showAddAdhocModal,
        setShowAddAdhocModal,
        subCompanyList,
        masterCompanyId,
        snackbarAlert
    } = useContext(PageContext);
    // initialize HttpContext
    const {
        POST,
    } = useContext(HttpContext);
    // initialize state
    const [subCompany, setSubCompany] = useState(null);
    const [amount, setAmount] = useState(0);
    const [masterPayment, setMasterPayment] = useState(false);
    const [companyList, setCompanyList] = useState([]);

    // // event handler for checkbox click
    // const onCheckboxClick = (e) => {
    //     setMasterPayment(masterPayment => masterPayment = e.target.checked)
    //     // set sub company to place
    //     if (e.target.checked == true) {
    //         setSubCompany(subCompany => subCompany = process.env.REACT_APP_MASTER_PAYOUT_INFO_PLACEHOLDER);
    //     }
    //     else {
    //         setSubCompany(subCompany => subCompany = null);
    //     }
    // }

    // event handler for submit click 
    const onSubmitClick = () => {
        return new Promise((resolve, reject) => {
            let response; 
            // validate amount is numeric 
            if (!isNumeric(amount.replaceAll(",", ""))) {
                snackbarAlert(true, 'Invalid Payment Amount.', 'error');
                reject(); 
                return;
            }
            // validate sub company
            if (!subCompanyList.includes(subCompany) && subCompany != process.env.REACT_APP_MASTER_PAYOUT_INFO_PLACEHOLDER) {
                snackbarAlert(true, 'Invalid Sub Company.', 'error');
                reject(); 
                return;
            }
            // let path = '/data/adhoc/adhocpage'; 
            let path = '/workflow/adhoc'
            // make request 
            POST(path, {
                mastercompanyid: masterCompanyId,
                companyid: subCompany,
                // amount: amount.replaceAll(",", ""),
                incentiveamount: amount.replaceAll(",", ""),
            }).then(res => {
                console.log(res);
                // hide modal 
                setShowAddAdhocModal(showAddAdhocModal => showAddAdhocModal = false);
                // trigger success alert
                snackbarAlert(true, 'Successfully uploaded data.', 'success');
                // refresh data on page
                return refreshFunction();
            }).then(res => {
                console.log(res);
                // resolve on success
                resolve(response); 
            }).catch(err => {
                console.log(err);
                // show alert on error
                snackbarAlert(true, 'Error uploading data.', 'error');
                // reject on error
                reject(err); 
            });
        }); 
    }

    // useEffect to clear subCompany and amount when subCompanyList changes
    useEffect(() => {
        setSubCompany(subCompany => subCompany = null);
        setAmount(amount => amount = 0);
        // set sub company list while removing 'All' if present 
        let index = subCompanyList.indexOf('All');
        if (index != -1) {
            setCompanyList(companyList => companyList = [...subCompanyList.slice(0, index), ...subCompanyList.slice(index + 1, subCompanyList.length)]);
        }
        else {
            setCompanyList(companyList => companyList = subCompanyList);
        }
    }, [subCompanyList]);

    return (
        <>
            <CCOffcanvas
                show={showAddAdhocModal}
                title='Add Ad-Hoc Payment'
                onCanvasClose={() => setShowAddAdhocModal(showAddAdhocModal => showAddAdhocModal = false)}
                bodyCssClassName="offcanvas-body bg-white p-3" 
                offCanvasClassName="offcanvas-parent-card-30"  
            >
                <div className="d-flex flex-column h-100">
                    <div className="d-flex flex-column flex-grow-1 overflow-scroll">
                        {/* <div class='modal-div'>
                            <FormControlLabel
                                value="end"
                                control={<Checkbox
                                    sx={{
                                        color: '#000000',
                                        '&.Mui-checked': {
                                            color: '#000000',
                                        },
                                    }} />}
                                label="Add Payment to Master Company"
                                labelPlacement="end"
                                sx={{
                                    color: 'black',
                                }}
                                checked={masterPayment}
                                onChange={(e) => onCheckboxClick(e)}
                            />
                        </div>
                        <br /> */}
                        {!masterPayment ?
                            <>
                                <div className="d-flex align-items-center justify-content-start">
                                    <AutoCompleteInput tag='Sub Company' value={subCompany} setValue={setSubCompany} list={companyList} topAlignTypography={true}/>
                                </div>
                            </>
                            : <></>}
                            <div className="d-flex align-items-center justify-content-start mt-3">
                                <PageInput tag='Payment Amount' value={amount} setValue={setAmount} topAlignTypography={true}/>
                            </div>
                    </div>
                    <div
                        className="d-flex justify-content-end p-3 w-100 offcanvas-footer z-2" style={{height: '65px'}}
                    >
                        <ApiRequestButton onButtonClick={onSubmitClick} />
                    </div>
                </div>
            </CCOffcanvas>
        </>
    );
}

export default AddAdhocPaymentModal;